export var isNumeric = function (x) {
    return typeof x === 'number';
};
export var getCurrentMilliseconds = function () {
    return Date.now();
};
if (typeof window === 'object' && typeof window.performance === 'object' && typeof window.performance.now === 'function') {
    getCurrentMilliseconds = function () {
        return window.performance.now();
    };
}
export var getEmptyStats = function () {
    var _a;
    return _a = {},
        _a["q" /* Queued */] = 0,
        _a["po" /* PreprocessedOut */] = {},
        _a["pw" /* PassedToWebWorker */] = 0,
        _a["wa" /* WebWorkerAccepted */] = 0,
        _a["wp" /* WebWorkerProcessed */] = 0,
        _a["wd" /* WebWorkerDropped */] = 0,
        _a["wr" /* WebWorkerDroppedReason */] = {},
        _a["ws" /* WebWorkerSent */] = 0,
        _a["pm" /* PassedToMinSink */] = 0,
        _a["sp" /* MinSinkProcessed */] = 0,
        _a["ss" /* MinSinkSent */] = 0,
        _a["sd" /* MinSinkDropped */] = 0,
        _a["pd" /* PreprocessingDuration */] = {},
        _a["md" /* MessagingDuration */] = 0,
        _a["d" /* WebWorkerProcessingDuration */] = 0,
        _a["b" /* Bytes */] = 0,
        _a["s" /* WebWorkerStatus */] = 0 /* Uninitialized */,
        _a;
};
//# sourceMappingURL=Utils.js.map